export default __webpack_public_path__ + "static/media/partner-big.2f7245b2.svg";